import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
} from "@mui/material";
import { useAuthStore } from "./store/authStore";
import { useOptInStore } from "./store/optInStore";

// Opt-in name this dialog is recorded under — same `email|name` shape the
// license opt-in already uses (see optInStore.js's generic fetchOptIn/setOptIn).
export const QUICK_USERS_GUIDE_OPT_IN = "quick_users_guide";

// Shown once per user (first login) via QuickUserGuideAutoShow, and
// re-openable on demand (e.g. a "User Guide" button) by any caller that
// controls `open`/`onClose` itself — the "don't show again" checkbox only
// affects the automatic first-login popup, not manual reopens.
const QuickUserGuideDialog = ({ open, onClose }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const user = useAuthStore((state) => state.user);
  const setOptIn = useOptInStore((state) => state.setOptIn);

  const handleClose = async () => {
    if (dontShowAgain) {
      const email = user?.email || user?.id;
      if (email) {
        await setOptIn(QUICK_USERS_GUIDE_OPT_IN, email);
      }
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      // The source image is 1672x838. Rather than MUI's fixed maxWidth
      // breakpoints (md tops out at 900px — much smaller than the image,
      // which is why it read as blurry/too-small), size the dialog up to
      // its natural width and let it shrink responsively on small viewports.
      PaperProps={{ sx: { width: "min(96vw, 1750px)", maxHeight: "92vh" } }}
    >
      <DialogTitle sx={{ color: "#2F3F5C" }}>Quick User's Guide</DialogTitle>
      <DialogContent dividers sx={{ p: 0, overflow: "auto" }}>
        <Box
          component="img"
          src="/quick-users-guide.webp"
          alt="ContinuousMFA quick user's guide — 5 easy steps to run your first MFA simulation"
          sx={{
            width: "100%",
            height: "auto",
            maxWidth: 1672,
            display: "block",
            mx: "auto",
          }}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", px: 3, py: 1.5 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            />
          }
          label="Don't show this again"
        />
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="outlined"
            href="/quick-users-guide.webp"
            download="ContinuousMFA-quick-users-guide.webp"
          >
            Download
          </Button>
          <Button onClick={handleClose} variant="contained">
            Got it
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default QuickUserGuideDialog;
